import { InjectionToken } from '@angular/core';
import type { AppConfig, BuildTimeEnvironment } from '@core/config/app-config.types';

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
export const BUILD_TIME_ENVIRONMENT = new InjectionToken<BuildTimeEnvironment>(
  'BUILD_TIME_ENVIRONMENT',
);
